/* unplugin-vue-components disabled */import { render } from "./ArticleDetails.vue?vue&type=template&id=102104e0&scoped=true"
import script from "./ArticleDetails.vue?vue&type=script&lang=js"
export * from "./ArticleDetails.vue?vue&type=script&lang=js"

import "./ArticleDetails.vue?vue&type=style&index=0&id=102104e0&lang=less&scoped=true"

import exportComponent from "E:\\Jweb\\结课作业\\KilaKila-Blog\\kilakila-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-102104e0"]])

export default __exports__